<div class="zef-text-h3">
  <ng-content></ng-content>
</div>

<div class="zone-status"></div>
